// test2522
(2522 && 0);
